import React, { useState, useEffect } from 'react';
import Slider from "react-rangeslider";
import 'react-rangeslider/lib/index.css';

import { axiosInstnace as Axios, getDaysForDaysPackage } from '../../util/util';
import { endPoints } from '../../config';
import NoPackage from './NoPackage';

const DayPackageContainer = props => {

  //Set initial state
  const [totalDays, handletotalDays] = useState(3);
  const [fctPerDay, handlefctPerDay] = useState(undefined);
  const [totalSecondages, handtotalSecondages] = useState(undefined);
  const [totalCost, handletotalCost] = useState(undefined);
  const [discount, handlediscount] = useState(undefined);
  const [discountedCost, handlediscountedCost] = useState(undefined);
  const [total, handletotal] = useState(undefined);

  //Fetching rodp
  useEffect(() => {
    if (props.rodp) {
      handleOnRangeChange(totalDays);
      handleRange(totalDays);
    }
  }, [props.rodp])

  useEffect(() => {
      handleRange(totalDays);
  }, [totalDays])
  //handle range change
  const handleRange = async () => {
    let days= getDaysForDaysPackage(totalDays);
    getPackage(days, totalDays);
  }

  //Get package from backend
  const getPackage= async (days, totalDays)=> {
    const response = await Axios.get(`${endPoints.getDaypakage}?days=${days}&totalDays=${totalDays}`);
    if(response && response.data.statusCode== 200) {
      let { data }= response.data.data;
      handleCost(data[0], days);
    }
  }

  //Handle total cost for package
  const handleCost= async (data, days)=> {
      console.log(data);
    let rodp = (props.rodp) / 10;
    let { fctPerDay, discount, totalSecondages }= data;
    let cost= fctPerDay * totalDays * rodp;
    let discountedCost= (discount * cost) / 100;
    let totalCost= cost - discountedCost;
    let totalSeconds = totalDays*fctPerDay;
    await handlefctPerDay(fctPerDay);
    await handtotalSecondages(totalSeconds);
    await handletotalCost(cost);
    await handlediscount(discount);
    await handlediscountedCost(discountedCost);
    await handletotal(totalCost);
  }

  const handleOnRangeChange = async e => {
    await handletotalDays(e);
  }

  //Choose package
  const choosePackage = async (fctPerDay, secondages, totalCost, discount, discountedCost,days, event) => {
    const data = {
      fctPerDay, days, secondages, discount,
      discountedCost, totalCost,
      station: props.station,
      type: "Day Based",
      rodp: props.rodp,
      customRodp: props.customRodp,
      startTime: this.props.startTime,
      endTime: this.props.endTime,
    }
    props.choosePackage(data);
  }

  //Return Day bassed package
  return (
    <div className="days_planning planning">
      <h2>Don’t Know, Which One ? Let Us Know How Many Days You Are Planning For</h2>
      {/* <div className="watermark"><img src="../../assets/images/logo_watermark.png" /></div> */}
      <div className="rangebar_wrapper">
        <div className="slidecontainer day_slider">
          <Slider
            value={totalDays}
            orientation="horizontal"
            min={3}
            max={90}
            labels={{ 3: "3", 30: "30", 60: "60", 90: "90" }}
            step={1}           
            onChange={handleOnRangeChange}
            // onChangeComplete={handleRange}
          />
        </div>
        {props.showPackage && <div className="planning_card-wrapper">
          <div className="calender"><img src="../../assets/images/calendar_icon.png" /></div>
          <div className="planning_card">
            
            {/* <div className="package_card_head">{totalDays} DAYS</div> */}
            
            <div className="package_card_head">{totalDays.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} DAYS</div>
                
         <div> 
         <div>
            <div className="planning_list_wrapper">
              <ul className="planning_card_list">
                <li><span className="pack_numb">{fctPerDay}</span> Seconds Per Day</li>
                <li>
                  <span className="pack_numb">
                    {totalSecondages? totalSecondages.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","): undefined}
                  </span>Total Secondages
                </li>
              </ul>
              <ul className="planning_card_list">
                <li><span className="pack_numb">{totalCost && totalCost.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} INR</span> Total Cost</li>
                <li><span className="pack_numb">{discount} %</span> Additional Benefit</li>
              </ul>
              <ul className="planning_card_list">
                <li><span className="pack_numb">{discountedCost && discountedCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} INR</span>  Discounted Cost</li>
              </ul>
            </div>
            </div>
            <span className="package_card_total planning_card_total">{total && total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} INR</span>
            <div className="choose_plan planning_btn"><button onClick={choosePackage.bind(this, fctPerDay, totalSecondages, totalCost, discount, discountedCost,totalDays)}>CHOOSE PLAN</button></div>
            <div className="package-card-footer">{`You’ve Got ${discount}% Discount`}</div>
            </div>
           
          </div>
        </div>}
        {
             !props.showPackage &&
              <NoPackage/>
            }
      </div>
    </div>
  )
}
export default DayPackageContainer;


// WEBPACK FOOTER //
// ./web/components/package/dayPackage.js